module.exports = __webpack_public_path__ + "static/img/img4.ae5487d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img4.jpg
// module id = hgu+
// module chunks = 0